require("./style/main.css")
require("./style/fonts.css")
require("./views/images/AssemblyLift_logo_with_text.png")
require("./views/images/akkoro_isotoxal_octagram_v2.png")
require("./views/images/akkoro_isotoxal_octagram_with_copy_v2.png")
require("./views/images/lambda-plus-wasm.png")
require("./views/images/icons/ethics_icon_2.png")
require("./views/images/icons/privacy_icon.png")
require("./views/images/service-example.png")
require("./views/images/function-example.png")

function render(elementId, html) {
    document.getElementById(elementId).innerHTML = html
}

const def = (v) => typeof v !== 'undefined'
const elem = (e, a, c) => `<${e} ${Object.keys(a).map(k => `${k}="${a[k]}"`).join(' ')}>${def(c) ? c : ``}</${e}>`
const polygon = a => elem("polygon", a)
const svg = (a, c) => elem("svg", a, c)

function renderBackground(width, height) {
    const opacity = 0.15
    const fill = "#654FF0"

    return svg({width, height},
        [
            polygon({
                points: `${width*0.75},0 ${width},0 ${width},${height} ${width*0.1},${height}`,
                opacity,
                fill
            }),
            polygon({
                points: `${width*0.9},0 ${width},0 ${width},${height} ${width*0.5},${height}`,
                opacity,
                fill
            }),
        ].join('')
    )
}

function jsentry() {
    const width = window.innerWidth
    const height = window.innerHeight
    render("bg", renderBackground(width, height))

    const adj = ["high_performance", "opinionated", "modern", "batteries_included"]
    const adjPrefix = ["a", "an", "a", "a"]
    const r = Math.floor(Math.random() * adj.length);
    render("random-adjective", adj[r])
    render("adj-prefix", adjPrefix[r])

    window.onresize = () => {
        const width = window.innerWidth
        const height = window.innerHeight
        render("bg", renderBackground(width, height))
    }
}

jsentry()
